exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.statistics_wrap{height:calc(100% - 30px);background:#f5f5f5\n}\n.statistics_wrap .tips_p{font-size:10px;text-align:right;line-height:30px;color:#5397F7\n}\n", "", {"version":3,"sources":["/data/data/jenkins/workspace/edu-gxzx-web-pro-new-study/src/components/views/studyCenter/switch/statistics/statisticsIndex.vue"],"names":[],"mappings":";AAuBA,iBACE,yBACA,kBAAmB;CAFrB;AAAA,yBAII,eACA,iBACA,iBACA,aACF;CAAC","file":"statisticsIndex.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.statistics_wrap{\n  height: calc(100% - 30px);\n  background: #f5f5f5;\n  .tips_p{\n    font-size: 10px;\n    text-align: right;\n    line-height: 30px;\n    color: #5397F7\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf2a8fa8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/studyCenter/switch/statistics/statisticsIndex.vue
// module id = iw7a
// module chunks = 96